import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import {
  EXPRESS_PAYMENT_TERMS,
  INDIVIDUAL_ACCOUNT_TYPE,
  SWEDEN_COUNTRY
} from './../constant/BusinessRules'; 

const InvoiceOffers = ({
  customer,
  setShowExpressPayment,
  setValue,
  watch,
  register,
  invoiceImg,
}) => {
  const { t } = useTranslation();

  const isExpressPaymentDisabled =
    EXPRESS_PAYMENT_TERMS.includes(customer?.paymentTerm) ||
    customer?.accountType === INDIVIDUAL_ACCOUNT_TYPE ||
    (customer?.country !== SWEDEN_COUNTRY && customer?.accountType !== INDIVIDUAL_ACCOUNT_TYPE);

  return (
    <div className="section-padding mb-4">
      <div className="col-sm-12">
        <div className="invoice-offers row mt-4">
          {customer?.country === "Sweden" ? (
          <div className="col w-100">
            <div className="col-md-8">
              <h6 className="text-dark mb-3 mt-3">
                {t('Do you want Express payment on the same day?')}{' '}
                <a
                  href="#"
                  onClick={(e) => {
                    if (!isExpressPaymentDisabled) {
                      setShowExpressPayment(true);
                      setValue('expressPayout', true);
                    }
                    e.preventDefault(); // Avoid page jump
                  }}
                >
                  {t('Read more')}
                </a>
              </h6>

              <input
                className="cursor-pointer"
                type="checkbox"
                checked={!isExpressPaymentDisabled && watch('expressPayout')}
                id="express-betalning"
                name="express-betalning"
                disabled={isExpressPaymentDisabled}
                {...register('expressPayout')}
                onClick={(e) => {
                  const checked = e.target.checked;
                  setShowExpressPayment(checked);
                  setValue('expressPayout', checked);
                }}
              />
              <img src={invoiceImg} className="ml-3 w-25 d-inline-block" alt="Invoice" />
            </div>
          </div>): <div className="col w-100"></div>}

          {/* Pension Section */}
        </div>
      </div>
    </div>
  );
};

export default InvoiceOffers;
